import { render, staticRenderFns } from "./ex-all-company-list.vue?vue&type=template&id=38dfe518&scoped=true&"
import script from "./ex-all-company-list.vue?vue&type=script&lang=js&"
export * from "./ex-all-company-list.vue?vue&type=script&lang=js&"
import style0 from "./ex-all-company-list.vue?vue&type=style&index=0&id=38dfe518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dfe518",
  null
  
)

export default component.exports